import { type TicketStatusFilter } from '../../hooks/useTicketList';

import { KVALITET_PARAM_KEYS } from './kvalitet-url-state';
import { type SessionsTab } from './SessionTabs';

export const parseSessionsTab = (params: URLSearchParams): SessionsTab => {
  const tab = params.get('tab');
  return tab === 'tickets' || tab === 'kvalitet' ? tab : 'sessions';
};

// Kvalitetsflikens filter hör bara till den fliken. De följer med när man går
// till den, men en annan flik ska inte bära dem vidare i sin länk.
export const searchParamsForTab = (current: URLSearchParams, tab: SessionsTab): URLSearchParams => {
  const rest = new URLSearchParams(current);
  rest.delete('tab');
  if (tab !== 'kvalitet') for (const key of KVALITET_PARAM_KEYS) rest.delete(key);
  if (tab !== 'tickets') rest.delete('ticket');
  return tab === 'sessions' ? rest : new URLSearchParams([['tab', tab], ...rest]);
};

export const ticketTabParams = (current: URLSearchParams, ticketId: string): URLSearchParams => {
  const next = searchParamsForTab(current, 'tickets');
  next.set('ticket', ticketId);
  return next;
};

export const parseFocusTicket = (params: URLSearchParams): string | null =>
  params.get('tab') === 'tickets' ? params.get('ticket') || null : null;

// En länk kan peka på en ticket i vilken status som helst, och förvalet "utkast"
// skulle dölja en issue eller en avvisad ticket.
export const initialTicketFilter = (focusTicketId: string | null): TicketStatusFilter =>
  focusTicketId ? 'all' : 'draft';

// Den öppnade ticketen kan ligga utanför filtret eller efter första sidan. Då
// visas den ovanför tabellen i stället för att inte synas alls.
export const isTicketOutsideList = (
  ticketId: string | null,
  items: ReadonlyArray<{ id: string }>,
): boolean => ticketId !== null && !items.some((item) => item.id === ticketId);
